module.exports = __webpack_public_path__ + "static/media/header-2.4366db09.jpg";